import { GLOBAL_THEME_COLOR } from '@constants/theme';
import { useAppDispatch } from '@core/configureStore';
import { openModal } from '@core/features';
import { Reservation } from '@core/models';
import { getReservationFullName } from '@utils/booking.util';
import { useReservationStatusColor } from '@utils/reservation.util';
import { ReservationStatusBadge } from '..';
import pluralize from 'pluralize';
import ReservationStateObserver from '@components/ReservationStateObserver';
import { Avatar } from 'antd';
import { stringToColour } from '@utils/string.util';
import { MIDDLE_STYLE } from '@constants/responsive';

const RenderReservationCellCard = ({ reservation }: { reservation: Reservation<any> }) => {
  const dispatch = useAppDispatch();
  const renderReservationStatusColor = useReservationStatusColor();

  const handleReservation = () => {
    dispatch(
      openModal({
        modalName: 'reservationDetailModal',
        extraParams: {
          existingReservation: reservation,
        },
      })
    );
  };
  return (
    <ReservationStateObserver reservation={reservation}>
      <div
        className="hover-to-border-highlight"
        onClick={handleReservation}
        style={{
          backgroundColor: GLOBAL_THEME_COLOR.$background_color,
          borderRadius: 5,
          overflow: 'hidden',
          border: `1px solid ${GLOBAL_THEME_COLOR.$border_color}`,
          height: '100%',
          cursor: 'pointer',
          ...MIDDLE_STYLE,
          justifyContent: 'flex-start',
        }}>
        <div
          style={{
            height: '100%',
            width: 4,
            marginRight: 10,
            backgroundColor: renderReservationStatusColor(reservation),
          }}></div>
        <Avatar
          size={22}
          style={{
            backgroundColor: stringToColour(getReservationFullName(reservation)),
            marginRight: 15,
            fontSize: 'smaller',
          }}>
          {reservation.firstName?.at(0)}
        </Avatar>
        <div
          style={{
            padding: '2px 0px',
          }}>
          <h4 style={{ fontSize: 13, fontWeight: '600' }}>{getReservationFullName(reservation)}</h4>
          <p style={{ fontSize: 11, color: GLOBAL_THEME_COLOR.$dark_text_color }}>
            {reservation.numberOfPeople} {pluralize('person', reservation.numberOfPeople)}
          </p>
        </div>
        <div style={{ position: 'absolute', right: 0, bottom: 0 }}>
          <ReservationStatusBadge
            style={{ padding: '2px 5px', fontSize: '10px' }}
            reservation={reservation}
          />
        </div>
      </div>
    </ReservationStateObserver>
  );
};

export default RenderReservationCellCard;
